// Applies to a text area - this will cause the text area to automatically resize
// to fit the text inside.
//
// opts --
// minHeight: The minimum height of this textarea, even if empty (100px)
// extra: Extra (vertical) space to add to the textarea height (0px)

!(function($) {
  $.fn.autoResize = function(opts) {
    opts = $.extend({ minHeight: 100, extra: 0 }, opts);

    this.filter('textarea')
      .each(function() {
        var target = $(this).toggleClass('auto-resize', true);

        var shadow = target
          .clone()
          .attr('tabIndex', -1)
          .css({ position: 'absolute', visibility: 'hidden', 'z-index': -100 })
          .insertBefore(target);

        if (target.css('box-sizing') == 'border-box') {
          shadow.width(target.width());
        }

        $.each(['id', 'name'], function(i, p) {
          shadow.removeAttr(p);
        });

        var current = -1;
        target
          .unbind('.autoResize')
          .bind(
            'keyup.autoResize keydown.autoResize change.autoResize autoResize.autoResize',
            function(e) {
              shadow
                .height(0)
                .val($(this).val())
                .scrollTop(99999);
              var height = Math.max(
                shadow.scrollTop() + opts.extra,
                opts.minHeight
              );
              if (height == current) return;
              target.css({ height: (current = height) });
              target.trigger('resized');
            }
          );
      })
      .trigger('autoResize');
    return this;
  };
})(jQuery);
